import { useEffect, useRef } from "react"

export function useOuterClick(onClick: () => void) {
	const innerRef = useRef(null) // returned to client, who marks "border" element
	useEffect(() => {
		document.addEventListener("click", handleClick)
		return () => document.removeEventListener("click", handleClick)
		function handleClick(e: any) {
			if (innerRef && innerRef.current) {
				const ref: any = innerRef.current
				if (!ref.contains(e.target)) {
					onClick?.()
				}
			}
		}
	}, [])

	return innerRef // return ref; client can omit `useRef`
}
